import { useEffect } from 'react'
import { Outlet, useNavigate, useParams, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function LanguageLayout() {
   const { lang } = useParams()
   const { i18n } = useTranslation()
   const navigate = useNavigate()
   const location = useLocation()

   useEffect(() => {
      if (!lang || !['tr', 'en'].includes(lang)) {
				 const currentLang = ['tr', 'en'].includes(i18n.language) ? i18n.language : 'en'

         navigate(`/${currentLang}${location.pathname}${location.search}`, { replace: true })
      } else {
         i18n.changeLanguage(lang)
      }
   }, [lang, i18n, navigate, location])

   return <Outlet />
}
